export const UPLOAD_IN_TWO_STEPS = 'MEDIAS/UPLOAD_IN_TWO_STEPS_REQUEST';
export const UPLOAD_IN_TWO_STEPS_SUCCESS = 'MEDIAS/UPLOAD_IN_TWO_STEPS_SUCCESS';
export const UPLOAD_IN_TWO_STEPS_FAILURE = 'MEDIAS/UPLOAD_IN_TWO_STEPS_FAILURE';

export const UPLOAD_IN_ONE_STEP = 'MEDIAS/UPLOAD_IN_ONE_STEP_REQUEST';
export const UPLOAD_IN_ONE_STEP_SUCCESS = 'MEDIAS/UPLOAD_IN_ONE_STEP_SUCCESS';
export const UPLOAD_IN_ONE_STEP_FAILURE = 'MEDIAS/UPLOAD_IN_ONE_STEP_FAILURE';
